import axios from 'axios';
import Keycloak from '../utils/Keycloak';

const Axios = axios.create({
    baseURL: process.env.REACT_APP_URL_API,
    timeout: 30000,
});

Axios.interceptors.request.use(
    async (config) => {
        const token = Keycloak.getInstance().token;

        if (token) {
            if (!config.headers) {
                config.headers = {};
            }
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error?.response?.status === 401) {
            window.localStorage.clear();
            Keycloak.getInstance().logout();
        }

        return Promise.reject(error);
    }
);

export default Axios;
